import Vue from 'vue'
import Router from 'vue-router'
import gk from '@/components/gk'
import zk from '@/components/zk2023'
import art from '@/components/art'
import gzgk from '@/components/gzgk' // 春季高考  高职高考
import ga from '@/components/ga' // 港澳台
import photo from '@/components/photo'
import yixuekao from '@/components/yixuekao' // 依学考
Vue.use(Router)

export default new Router({
  routes: [
    {
      // },
      // {
      // path: '/',
      // name: 'zk',
      // component: zk
      // },
      //  {
      path: '/',
      name: 'zk',
      component: zk
      // path: '/',
      // name: 'photo',
      // component: photo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js